import { Component } from '@angular/core'; 
import { HttpClient } from '@angular/common/http'; 
@Component({
  selector: 'app-csv-upload',
  templateUrl: './csv-upload.component.html',
  styleUrls: ['./csv-upload.component.css']
})
export class CsvUploadComponent {
  selectedFile: File | null = null;
  parsedData: any[] = [];

  constructor(private http: HttpClient) {}
 
 

  uploadFile() {
    if (this.parsedData.length > 0) {
      this.http.post('/api/your-endpoint', this.parsedData)
        .subscribe(response => {
          console.log('Upload successful!', response);
        }, error => {
          console.error('Upload failed!', error);
        });
    }
  }
}
